export default __webpack_public_path__ + "static/22-82b133b7f0c34a44db01cc0e9b7dfa60.jpg";